import React from 'react';

import {Trans} from 'react-i18next';
import {formatArea, localizationMap} from '@app/util/format-area.js';
import {getAreaUnits} from '@app/selectors/measurements';
import {number} from 'prop-types';
import {useSelector} from 'react-redux';

const AreaIndicator = ({squareMeters}) => {
  const units = useSelector(getAreaUnits);

  const area = formatArea(squareMeters, units, '0,0.[000]');
  return localizationMap[units] ? (
    <Trans i18nKey={localizationMap[units]} values={{area}} />
  ) : null;
};

AreaIndicator.propTypes = {
  squareMeters: number,
};

export default AreaIndicator;
